(function() { module.exports = this["ReactDOM"]; }());


//////////////////
// WEBPACK FOOTER
// external "ReactDOM"
// module id = 549
// module chunks = 0